import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { useMemo } from 'react'
import type { Color, Look } from '../types/Color'
import { getModelHeight } from '../utils/getModelHeight/getModelHeight'
import { getModelSize } from '../utils/getModelSize/getModelSize'

interface ModelSizes {
	modelHeight?: string
	modelSizeCode?: string
}

export const useModelInfo = ({
	selectedColor,
	selectedLook,
}: {
	selectedColor?: Color
	selectedLook?: Look
}): ModelSizes => {
	const { enabled: showHeightInInches } = useFeatureFlag(
		featureFlagKeys.PdpModelSizeInInches
	)
	const modelSizes: ModelSizes = useMemo(() => {
		if (!selectedColor || !selectedLook) {
			return {}
		}
		return {
			modelHeight: getModelHeight({
				selectedLook,
				showHeightInInches,
			}),
			modelSizeCode: getModelSize({ selectedColor, selectedLook }),
		}
	}, [selectedColor, selectedLook, showHeightInInches])

	return modelSizes
}
